<template>
  <div style="display: inline-block">
    <a :style="textColorStyle(textColor)" @click="open()"> {{ text }} </a>
    <el-dialog :title="$t('order.show.go_to')" :visible.sync="isShowModal" width="400px" append-to-body>
      <div class="text-center" @click="isShowModal = false">
        <router-link :to="{ path: sourceStationUrl }" :class="{ 'link-disabled': !can(stationAuth) }">
          <div class="go-to-url-box m-r-20">
            <img src="/images/order/station.svg" />
            <div class="m-t-10">{{ $t('charge_station.label') }}</div>
          </div>
        </router-link>

        <router-link :to="{ path: sourceChargerUrl }" :class="{ 'link-disabled': !can(chargerAuth) }">
          <div class="go-to-url-box">
            <img src="/images/order/charger.svg" />
            <div class="m-t-10">{{ $t('charger.name') }}</div>
          </div>
        </router-link>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pileApi from '@/api/ev_charging_pile'
import Auth from '@/helpers/authorizations'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    /**
     * 字体颜色
     */
    textColor: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      isShowModal: false,
      source: null,
      sourceStationUrl: null,
      sourceChargerUrl: null,
      stationAuth: null,
      chargerAuth: null
    }
  },
  watch: {
    source(val) {
      if ($.isEmptyObject(val)) return null
      switch (val.source_type) {
        case 'EvcsEquipment':
          this.sourceStationUrl = `/evcs_stations/${val.station_id}/detail`
          this.sourceChargerUrl = `/evcs_stations/${val.station_id}/equipments?evcs_equipment_id=${val.charger_id}`
          this.stationAuth = Auth.showEvcsStation
          this.chargerAuth = Auth.showEvcsEquipment
          break
        case 'Charger':
          this.sourceStationUrl = `/charge_stations/${val.station_id}/detail`
          this.sourceChargerUrl = `/chargers/${val.charger_id}/detail`
          this.stationAuth = Auth.showChargeStation
          this.chargerAuth = Auth.showCharger
          break
        default:
          this.sourceStationUrl = `/ev_charging_stations/${val.station_id}/detail`
          this.sourceChargerUrl = `/ev_charging_piles/${val.charger_id}`
          this.stationAuth = Auth.showEvChargingStation
          this.chargerAuth = Auth.showEvChargingPile
          break
      }
    }
  },
  methods: {
    open() {
      this.isShowModal = true
      pileApi.getSource(this.id).then(response => {
        this.source = response.data
      })
    },
    /**
     * 点击的文字样式
     *
     * @param {string} textColor 文字颜色
     * @returns {string} Css 样式
     */
    textColorStyle(textColor) {
      if (textColor === undefined) {
        return null
      }
      return `color: ${textColor}`
    }
  }
}
</script>
<style lang="scss" scoped>
.go-to-url-box {
  display: inline-block;
  width: 160px;
  height: 160px;
  border: 1px solid #cbcfd8;
  text-align: center;
  &:hover {
    border: 1px solid #41c981;
    div {
      color: #41c981;
    }
  }
}
</style>
